
/* HELPER FUNCTION TO DETERMINE CAPATALIZE FRST CHARACTER */
const capitalizeFirstCharacter = (str: string | null) => {
    if (!str) {
        return
    }
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase()
};

export default capitalizeFirstCharacter;